import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

const SettingUpNavBlock = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-wrap gap-lg justify-content-center">
      {/* 
      // Option temporarily hidden (TEAMB-1969)
      {isAdmin && (
        <Button
          className="nc_button-square"
          label="Sites"
          icon="nc_icon-nc_levers icon-md"
          iconPos="right"
          aria-label="Sites"
          rounded
          outlined
          onClick={() => navigate('/settings')}
          id="navBlockSettings"
        />
      )} */}
      <Button
        className="nc_button-square"
        label="Classes & Rosters"
        icon="nc_icon-nc_join icon-md"
        iconPos="right"
        aria-label="Classes & Rosters"
        rounded
        outlined
        onClick={() => navigate('/classes-rosters')}
        id="navBlockClassesRosters"
      />
      <Button
        label="Students"
        icon="nc_icon-nc_person icon-md"
        iconPos="right"
        aria-label="Students"
        rounded
        className="nc_button-square"
        outlined
        onClick={() => navigate('/students')}
        id="navBlockStudents"
      />
      <Button
        label="Teachers & Admins"
        icon="nc_icon-nc_person icon-md"
        iconPos="right"
        aria-label="Teachers & Admins"
        className="nc_button-square"
        rounded
        outlined
        onClick={() => navigate('/teachers')}
        id="navBlockTeachersAdmins"
      />
    </div>
  );
};

export default SettingUpNavBlock;
